var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[ 'thematicItem', _vm.iconClass ],on:{"click":_vm.showThematic}},[_c('img',{staticClass:"thematicIcon",attrs:{"src":_vm.getIcon(),"alt":_vm.thematicItem.subtitle}})])}
var staticRenderFns = []

export { render, staticRenderFns }